module.exports = __webpack_public_path__ + "static/img/4.14f1b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/4.png
// module id = HCzN
// module chunks = 1